import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import CostCenterDetails from '../../components/CostCenterDetails/CostCenterDetails'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

const CostCenterDetailsPage = () => {
    return (
        <>
            <Helmet>
                <title>Contract Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <CostCenterDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default CostCenterDetailsPage